import React from 'react';
import PropTypes from 'prop-types';
import { FlexTableCol } from 'virtues-bootstrap';
import cx from 'classnames';

import { ReactComponent as SortDown } from 'svg/caret-down.svg';
import { ReactComponent as SortUp } from 'svg/caret-up.svg';
import s from './styles.module.scss';

const HeaderColumn = ({ sort, currentKey, title, desc, handleClick }) => {
  const handleSortingChange = () => {
    handleClick({ sort: currentKey, desc: sort === currentKey && !desc });
  };

  return currentKey ? (
    <FlexTableCol className={s.col}>
      <div
        role="button"
        tabIndex={sort}
        onKeyPress={handleSortingChange}
        className={cx({
          [s.title]: currentKey,
          [s.active]: sort === currentKey,
          [s.withKey]: currentKey,
        })}
        onClick={handleSortingChange}
      >
        {title}
        {sort === currentKey && !desc ? <SortUp /> : <SortDown />}
      </div>
    </FlexTableCol>
  ) : (
    <FlexTableCol>{title}</FlexTableCol>
  );
};

HeaderColumn.defaultProps = {
  currentKey: '',
};

HeaderColumn.propTypes = {
  title: PropTypes.string.isRequired,
  currentKey: PropTypes.string,
  sort: PropTypes.string.isRequired,
  desc: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default HeaderColumn;
